import { environment } from './environment';

export class EnvironmentConfig {
    environment: any;
    constructor() {
        this.environment = environment;
    }
}
